/*
 * VAUNI CUSTOM: Almond-kampanjens belopp i andra valutor än SEK (snippets/vauni-almond-campaign.liquid).
 *
 * Shopify räknar om rabatter med fast belopp från butiksvalutan med samma kurs som
 * window.Shopify.currency.rate, avrundat till öre – precis som konfiguratorn gör.
 * Rubrikbeloppet avrundas NEDÅT till ett runt tal så att vi aldrig lovar mer än kassan ger.
 * Idempotent: snippeten kan ladda skriptet flera gånger på samma sida.
 */
(() => {
  const formatterFromSample = (sample) => {
    const match = typeof sample === "string" && sample.match(/1(\D{0,2}?)234\1?567(?:(\D)00)?/);

    if (!match) {
      return null;
    }

    const thousands = match[1] || "";
    const decimalSep = match[2] || null;

    return (cents, { whole = false } = {}) => {
      const amount = cents / 100;
      let core;

      if (decimalSep && !whole) {
        const [int, fraction] = amount.toFixed(2).split(".");
        core = int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + decimalSep + fraction;
      } else {
        core = String(Math.round(amount)).replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      }

      return sample.replace(match[0], core);
    };
  };

  const run = () => {
    const rate = parseFloat(window.Shopify?.currency?.rate);
    const format = formatterFromSample(window.vauniAlmondSample);

    if (!(rate > 0) || !format) {
      return; // generisk text ligger kvar
    }

    document.querySelectorAll("[data-almond-convert]:not([data-almond-ready])").forEach((root) => {
      root.setAttribute("data-almond-ready", "");

      const cents = Math.round(Number(root.dataset.almondBase) * rate);
      const price = Number(root.dataset.almondPrice);

      if (!(cents > 0) || !(price > 0)) {
        return;
      }

      // 588,79 → 580 · 660,07 → 660 · 6 330,22 → 6 300
      const units = cents / 100;
      const step = units >= 100 ? 10 ** (Math.floor(Math.log10(units)) - 1) : 1;
      const rounded = Math.floor(units / step) * step * 100;

      root.querySelectorAll("[data-almond-amount]").forEach((el) => {
        el.textContent = format(rounded, { whole: true });
      });

      // Nettopriset avrundas UPPÅT till hel enhet (3 679,67 € → 3 680 €): kassan blir aldrig dyrare än sidan
      const net = Math.ceil(Math.max(price - cents, 0) / 100) * 100;

      root.querySelectorAll("[data-almond-net]").forEach((el) => {
        el.textContent = format(net, { whole: true });
      });

      // Ordinarie pris i samma stil (utan ,00 när beloppet är jämnt)
      root.querySelectorAll("[data-almond-was]").forEach((el) => {
        el.textContent = format(price, { whole: price % 100 === 0 });
      });

      root.querySelectorAll("[data-almond-generic]").forEach((el) => {
        el.hidden = true;
      });

      root.querySelectorAll("[data-almond-specific]").forEach((el) => {
        el.hidden = false;
      });

      if (root.hasAttribute("data-almond-specific")) {
        root.hidden = false;
      }
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }

  document.addEventListener("shopify:section:load", run);
})();
